import * as React from 'react'
import { Provider } from 'react-redux'
import { HashRouter } from 'react-router-dom'
import App from './App'

type ValueProps = {
  store: any
}

export default class Root extends React.Component<ValueProps, {}> {

  render(): React.ReactNode {
    const {store} = this.props;

    return (
      <Provider store={store}>
        <HashRouter>
          <App/>
        </HashRouter>
      </Provider>
    )
  }
}
